<template>
    <div id="step2">
        <h3><img src=".././assets/images/step2-title.svg"> スタイルを選ぶ</h3>
        <div class="radius_wrapper black_ver ">
            <p>対応スタイル一覧</p>
            <div v-if="item_data" id="curtain">
                <div class="pickup_box">
                    <p class="pickup_title">PICKUP</p>
                    <accordion2/>
                </div>
                <accordion
                        v-for="(item, index) in $store.state.xlsx_data.style_group1_sort"
                        v-bind:category="item"
                />
            </div>

<!--            <div class="overflow">-->
<!--                <p>Coming Soon ８月２日公開予定</p>-->
<!--            </div>-->

        </div>
    </div>
</template>

<script>
    import accordion  from './step2_parts/Accordion.vue'
    import accordion2 from './step2_parts/Accordion2.vue'
    export default {
        name: 'STEP2',
        components: {
            accordion,accordion2
        },
        data() {
            return {
                style_selected: '',
                isActive: false,
                check_category: {},
            }
        },
        computed: {
            item_data: {
                get: function () {
                    if(
                        this.$store.state.step1_data.item_number &&
                        this.$store.state.xlsx_data.item_data &&
                        typeof(this.$store.state.xlsx_data.item_data['FT'+this.$store.state.step1_data.item_number]) !=='undefined'
                    ){
                        return true
                    }
                    return false
                },
            },
        },
        methods: {
            active: function () {
                this.isActive = !this.isActive
            }
        },
    }
</script>

<style scoped>

</style>